module.exports = __webpack_public_path__ + "static/media/portse.66fa944a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portse.jpg
// module id = 5739
// module chunks = 0